var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCopyAccountBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 20,
    viewBox: "0 0 17 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6 16C5.45 16 4.97933 15.8043 4.588 15.413C4.196 15.021 4 14.55 4 14V1.99999C4 1.44999 4.196 0.978993 4.588 0.586993C4.97933 0.19566 5.45 -6.67572e-06 6 -6.67572e-06H15C15.55 -6.67572e-06 16.021 0.19566 16.413 0.586993C16.8043 0.978993 17 1.44999 17 1.99999V14C17 14.55 16.8043 15.021 16.413 15.413C16.021 15.8043 15.55 16 15 16H6ZM6 14H15V1.99999H6V14ZM2 20C1.45 20 0.979 19.8043 0.587 19.413C0.195667 19.021 0 18.55 0 18V4.99999C0 4.71666 0.0960001 4.47899 0.288 4.28699C0.479333 4.09566 0.716667 3.99999 1 3.99999C1.28333 3.99999 1.521 4.09566 1.713 4.28699C1.90433 4.47899 2 4.71666 2 4.99999V18H12C12.2833 18 12.521 18.096 12.713 18.288C12.9043 18.4793 13 18.7167 13 19C13 19.2833 12.9043 19.5207 12.713 19.712C12.521 19.904 12.2833 20 12 20H2ZM6 1.99999V14V1.99999Z",
    fill: "#1FD7AE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopyAccountBlack);
export default __webpack_public_path__ + "static/media/copyAccountBlack.d180eb59.svg";
export { ForwardRef as ReactComponent };